import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import Tooltip from "components/Tooltip";
import { lccStore } from "./LCCStore";
import { skeleton } from "utils";

const Totals = () => {
  const { t, i18n } = useTranslation();
  const { totals, loadingTotals } = lccStore;

  if (loadingTotals) return <div className="mb-6">{skeleton("h-24")}</div>;
  if (!totals) return null;

  const cards = [
    {
      label: t("lcc.installedCost"),
      tooltip: t("lcc.installedCostTooltip"),
      value: totals.installed_cost_eur,
      suffix: "€",
    },
    {
      label: t("lcc.maintenancePV"),
      tooltip: t("lcc.maintenancePVTooltip"),
      value: totals.maintenance_pv_eur,
      suffix: "€",
    },
    {
      label: t("lcc.replacementPV"),
      tooltip: t("lcc.replacementPVTooltip"),
      value: totals.replacement_pv_eur,
      suffix: "€",
    },
    {
      label: t("lcc.totalPV"),
      tooltip: t("lcc.totalPVTooltip"),
      value: totals.total_pv_eur,
      suffix: "€",
      highlight: true,
    },
    {
      label: t("lcc.totalPerM2BGF"),
      tooltip: t("lcc.totalPerM2BgfTooltip"),
      value: totals.total_eur_per_m2_bgf,
      suffix: "€/m²",
    },
  ];

  return (
    <div className="grid grid-cols-5 gap-4 mb-6">
      {cards.map((card) => (
        <div
          key={card.label}
          className={`rounded-lg border p-4 ${
            card.highlight
              ? "bg-indigo-50 border-indigo-300"
              : "bg-white border-gray-300"
          }`}
        >
          <div className="text-xs font-medium text-gray-500 mb-1 flex items-center gap-1">
            <span>{card.label}</span>
            <Tooltip content={card.tooltip} />
          </div>
          <div
            className={`text-xl font-semibold ${
              card.highlight ? "text-indigo-700" : "text-gray-900"
            }`}
          >
            {card.value?.toLocaleString(i18n.language, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}{" "}
            {card.suffix}
          </div>
        </div>
      ))}
    </div>
  );
};

export default observer(Totals);
